import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const OnboardingPage = lazy(() => import('src/pages/onboarding/onboarding'));

// ----------------------------------------------------------------------

const onboarding = {
  path: 'onboarding',
  element: (
    <Suspense fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  ),
  children: [
    {
      path: ':uuid',
      element: <OnboardingPage />,
    },
  ],
};

export const onboardingRoutes = [onboarding];
